"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("../Themes/styled-components"));
var Modal_1 = __importStar(require("../Modal"));
var Icon_1 = __importDefault(require("../Icon"));
var Button_1 = __importDefault(require("..//Button"));
var CenteredModalContent = styled_components_1.default(Modal_1.ModalContent)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var AlertModal = /** @class */ (function (_super) {
    __extends(AlertModal, _super);
    function AlertModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AlertModal.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, children = _a.children, handleClose = _a.handleClose, theme = _a.theme;
        return (React.createElement(Modal_1.default, { centered: true, size: "xs", isOpen: isOpen, handleClose: handleClose },
            React.createElement(CenteredModalContent, null,
                React.createElement(Icon_1.default, { name: "error", size: "xl", color: theme.color.danger }),
                React.createElement("br", null),
                children),
            React.createElement(Modal_1.ModalActions, null,
                React.createElement("div", null),
                React.createElement(Button_1.default, { onClick: handleClose }, "OK"))));
    };
    return AlertModal;
}(React.PureComponent));
exports.default = styled_components_1.withTheme(AlertModal);
var templateObject_1;
